export default __webpack_public_path__ + "static/media/dark_product_icon.0c9c92f9.svg";